import React, { useState } from 'react';
import { Button, TextField, Box, Typography } from '@mui/material'; 
import { confirmPasswordReset, requestPasswordReset } from '../offchain-logic/services';
// Importa le tue API di reset qui

type FlowState = 'INITIAL' | 'CODE_ENTRY' | 'SUCCESS';

interface ForgotPasswordFlowProps {
    initialUsername?: string; // Lo rendiamo opzionale
    onBackToLogin?: () => void;
}

const ForgotPasswordFlow: React.FC<ForgotPasswordFlowProps> = ({ initialUsername = '', onBackToLogin }) => {

    const [username, setUsername] = useState(initialUsername);
    const [flowState, setFlowState] = useState<FlowState>('INITIAL');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');

    // Chiamata all'API requestPasswordReset
    const handleRequestReset = async (e: React.FormEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setError('');
        try {
            await requestPasswordReset(username, (err, res) => {
                if(err !== null){
                    //props.handleOpenToast("Si è verificato un problema, riprova più tardi.", 'error');
                    console.error(err);
                }
                console.log("res: " + res);
                if(res !== null){
                    setFlowState('CODE_ENTRY');
                }
            });
        } catch (err) {
            // Gestisci errori come 'UserNotFoundException'
            setError("Impossibile inviare il codice. Verifica l'username.");
        }
    };

    // Chiamata all'API confirmPasswordReset
    const handleConfirmReset = async (e: React.FormEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setError('');
        try {
            await confirmPasswordReset(username, code, newPassword, (err, res) => {
                if(err !== null){
                    //props.handleOpenToast("Si è verificato un problema, riprova più tardi.", 'error');
                    console.error(err);
                }
                console.log("res: " + res);
                if(res !== null){
                    setFlowState('SUCCESS');
                }
            });
        } catch (err) {
            // Gestisci errori come 'CodeMismatchException' o 'InvalidPasswordException'
            setError("Errore nella conferma. Verifica il codice o la nuova password.");
        }
    };

    // --- Componente: Richiesta Username/Email ---
    const InitialForm = (
        <Box component="form" onSubmit={handleRequestReset} sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
                Inserisci il tuo username o email. Riceverai un codice di verifica.
            </Typography>
            <TextField
                label="Username / Email"
                fullWidth
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
            />
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                Invia Codice di Reset
            </Button>
        </Box>
    );

    // --- Componente: Inserimento Codice e Nuova Password ---
    const CodeEntryForm = (
        <Box component="form" onSubmit={handleConfirmReset} sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
                Abbiamo inviato un codice a **{username}**. Inserisci il codice e la tua nuova password.
            </Typography>
            <TextField
                label="Codice di Verifica"
                fullWidth
                required
                value={code}
                onChange={(e) => setCode(e.target.value)}
                sx={{ mb: 2 }}
            />
            <TextField
                label="Nuova Password"
                type="password"
                fullWidth
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
            />
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                Conferma e Resetta
            </Button>
            {/* Pulsante per rinviare il codice se necessario */}
            <Button type="button" variant="text" onClick={() => handleRequestReset(new Event('submit') as any)}>
                Rinvia Codice
            </Button>
        </Box>
    );
    
    // --- Componente Principale ---
    return (
        <Box sx={{ maxWidth: 400, mx: 'auto', p: 3 }}>
            <Typography variant="h5" sx={{ mb: 3 }}>
                Password Dimenticata
            </Typography>

            {error && (
                <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>
            )}

            {flowState === 'INITIAL' && InitialForm}
            {flowState === 'CODE_ENTRY' && CodeEntryForm}
            
            {flowState === 'SUCCESS' && (
                <Box>
                    <Typography color="success.main">Password aggiornata con successo!</Typography>
                    <Button type="button" onClick={onBackToLogin || (() => setFlowState('INITIAL'))}>Torna al Login</Button>
                </Box>
            )}
        </Box>
    );
};

export default ForgotPasswordFlow;